import { render, staticRenderFns } from "./BoardSharedScene.vue?vue&type=template&id=5888b460&scoped=true"
import script from "./BoardSharedScene.vue?vue&type=script&lang=js"
export * from "./BoardSharedScene.vue?vue&type=script&lang=js"
import style0 from "./BoardSharedScene.vue?vue&type=style&index=0&id=5888b460&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5888b460",
  null
  
)

export default component.exports